import { Modal, App } from 'antd';
import React from 'react'
import { useGoodsTypeDelMutation } from '../../store/ReactWebSiteApi';

function GoodsTypeDel(props) {
    const { message } = App.useApp();
    const {confirm} = Modal; 
    const [submitDel] = useGoodsTypeDelMutation()
    return (
        <>
            {props.egt_state==='2' &&  <a onClick={() => {
                            confirm({
                                title: '确定删除吗？',
                                content: props.egt_name,
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    submitDel({
                                        egt_id:props.egt_id,
                                        egt_state:'2'
                                    }).then((res) => {
                                        if (res.data.Status === 'success') {
                                            message.info('删除成功！');
                                        }
                                        if (res.data.Status === "fail") {
                                            message.error('删除失败！'+res.data.Message)
                                        }
                                    })
                                },
                                onCancel() {
                                console.log('Cancel');
                                },
                            });
                        }}>删除</a>}
            {props.egt_state==='1'&&<a onClick={() => {
                            confirm({
                                title: '确定取消删除吗？',
                                content: props.egt_name,
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    submitDel({
                                        egt_id:props.key,
                                        egt_state:'1'
                                    }).then((res) => {
                                        if (res.data.Status === 'success') {
                                            message.info('取消删除成功！');
                                        }
                                        if (res.data.Status === "fail") {
                                            message.error('取消删除失败！'+res.data.Message)
                                        }
                                    })
                                },
                                onCancel() {
                                console.log('Cancel');
                                },
                            });
                        }}>取消删除</a>}
        
        </>
    )
}

export default GoodsTypeDel